export default "__VITE_ASSET__De6I8YuR__"